import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { CreateBadgeRequest, DeleteBadgeRequest, UpdateBadgeRequest } from './badge.types';

import { requestCreateBadge, requestDeleteBadge, requestUpdateBadge, requestViewBadges } from './badge.actions';

export const useBadgeApi = () => {
  const dispatch = useDispatch();

  const createBadge = useCallback(
    (requestData: CreateBadgeRequest, onSuccess?: () => void) => {
      dispatch(requestCreateBadge({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const viewBadges = useCallback(() => {
    dispatch(requestViewBadges());
  }, [dispatch]);

  const updateBadge = useCallback(
    (requestData: UpdateBadgeRequest, onSuccess?: () => void) => {
      dispatch(requestUpdateBadge({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const deleteBadge = useCallback(
    (requestData: DeleteBadgeRequest, onSuccess?: () => void) => {
      dispatch(requestDeleteBadge({ requestData, onSuccess }));
    },
    [dispatch]
  );

  return { createBadge, viewBadges, updateBadge, deleteBadge };
};
